// extracted by mini-css-extract-plugin
export var smallSpinner = "_qv-0";